/**
 * Number formatters for the offers table. Same logic as
 * `dashboard/lib/formatters.ts` — duplicated per task guidance
 * because the data models differ.
 */

function isMissing(v: number | null | undefined): boolean {
  if (v === null || v === undefined) return true
  if (typeof v !== "number") return true
  return Number.isNaN(v)
}

export function formatCurrency(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return "$" + Number(value).toFixed(2)
}

export function formatNumber(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return Number(value).toLocaleString("en-US")
}

export function formatPercent(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return Number(value).toFixed(2) + "%"
}
